module.exports = __webpack_public_path__ + "static/media/imagen.af2fc53f.png";